import { render, staticRenderFns } from "./credits-buy-modal.vue?vue&type=template&id=1e88a6ee&"
import script from "./credits-buy-modal.vue?vue&type=script&lang=js&"
export * from "./credits-buy-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports